export default "/aWBTC.26c63b68dbb5bff13820d78610859ce5.png";